import { IRootState } from '../../types/redux/root';
import { ITablesStateItem } from '../../types/redux/tables';

export const tableStateSelector = (tableName: string) => (root: IRootState): ITablesStateItem | undefined => root.tables[tableName];
